import React, { useEffect, useState } from 'react';
import CardOrderToday from './CardOrderToday';
import { useNavigate } from 'react-router-dom';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useCartContext } from '../../Contexts/CartContext';
import Scrollbars from 'react-custom-scrollbars-2';
import BoxContentEndScrollbars from './BoxContentEndScrollbars';
import CustomerService from '../../Services/CustomerService';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { useLoginContext } from '../../Contexts/LoginContext';
import { ImSpinner8 } from 'react-icons/im';
import { TbMoodConfuzed } from 'react-icons/tb';
import ButtonPrimary from '../Form/ButtonPrimary';
import { isOrderOpen } from '../../Utils/Helpers';
import { useTranslation } from 'react-i18next';
import { useOrderHook } from '../../Hooks/OrderHook';

type Order = {
    id: string;
    status: number;
};

const OrdersToday = () => {

    const { t } = useTranslation();
    const { getLinkToHome } = useStoreHook();
    const { goToOrderView, getOrderDetail } = useOrderHook();
    const { setShowOrderDetail } = useCartContext();
    const { user, isAuthenticated } = useLoginContext();
    const { setShowTodayOrders } = useLayoutContext();
    const { orderType } = useOrderTypeContext();
    const [ ordersTodayList, setOrdersTodayList ] = useState<Order[]>([]);
    const [ ordersTodayListOpened, setOrdersTodayListOpened ] = useState<Order[]>([]);
    const [ ordersTodayListOthers, setOrdersTodayListOthers ] = useState<Order[]>([]);
    const [ hasOrdersToday, setHasOrdersToday ] = useState(false);
    const [ loadingOrders, setLoadingOrders ] = useState(false);
    const navigate = useNavigate();

    const [showShadow, setShowShadow] = useState(false);
    const handleScrollFrame = (values: any) => {
        const { scrollTop, scrollHeight, clientHeight } = values;
        // Verifica se o scroll está no início ou no fim para controlar a sombra
        if (scrollTop >= 0 && scrollTop + clientHeight < scrollHeight) {
            setShowShadow(true);
        } else {
            setShowShadow(false);
        }
    }

    const getDetail = async (order_id: number) => {
        getOrderDetail(order_id);
    }

    const getOrdersToday = async () => {
        if (!user?.id || !isAuthenticated || orderType == null) return;
        setLoadingOrders(true);
        const payload = {
            user_id: user.id,
        }
        try {
            const customerService = new CustomerService(orderType);
            const response = await customerService.getCustomerOrdersToday(payload);
            if (response.data) {
                setOrdersTodayList(response.data);
            }
        } catch (error: any) {
            setOrdersTodayList([]);
        } finally {
            setLoadingOrders(false);
        }
    }

    useEffect(() => {
        getOrdersToday();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setOrdersTodayListOpened(ordersTodayList.filter((order) => isOrderOpen(order)))
        setOrdersTodayListOthers(ordersTodayList.filter((order) => !isOrderOpen(order)))
        setHasOrdersToday(ordersTodayList.length > 0 && !loadingOrders);
    }, [ordersTodayList, loadingOrders]);

    const handleBackToHome = () => {
        navigate(getLinkToHome());
        setShowOrderDetail(false);
        setShowTodayOrders(false);
    }


    const handleGetDetail = (order: any) => {
        if (isOrderOpen(order)) {
            goToOrderView(order.id);
            setShowTodayOrders(false);
        } else {
            getDetail(order.id);
        }
    }

    return (
        <div className="flex flex-col justify-between h-full">
            <div className='relative grid h-full gap-4'>

                <div className='relative h-full' id="boxScroll_customerOrders">
                    <Scrollbars autoHide={true} className='min-h-full' onScrollFrame={handleScrollFrame}>
                        {loadingOrders &&
                            <div className="flex items-center justify-center gap-1 min-h-full text-gray-500"><ImSpinner8 className="animate-spin" /><span>{t('orders_today.loading_orders')}</span></div>
                        }

                        {ordersTodayList.length === 0 && !loadingOrders &&
                            <section className='flex flex-col w-full h-full items-center justify-center text-center'>
                                <TbMoodConfuzed size={50} className="mb-3 fadeInIcon" />
                                <div className='text-xl font-bold'>{t('orders_today.no_orders_title')}</div>
                                <p className='leading-5 px-2'>{t('orders_today.no_orders_message')}</p>

                                <ButtonPrimary
                                    onClick={handleBackToHome}
                                    className="mt-6">
                                    {t('orders_today.button_start')}
                                </ButtonPrimary>
                            </section>
                        }

                        {hasOrdersToday &&
                            <div className='flex flex-col gap-10 p-4' id='scrollContent_customerOrders'>

                                {ordersTodayListOpened.length > 0 &&
                                    <div className='flex flex-col gap-3'>
                                        <div className='flex items-center gap-2 justify-center'>
                                            <hr className='border-gray-100 w-5' />
                                            <span className='text-nowrap font-bold text-base text-shopfood-title'>{t('orders_today.open_orders_title')}</span>
                                            <hr className='border-gray-100 w-full' />
                                        </div>
                                        {ordersTodayListOpened.map((order: any) => <CardOrderToday order={order} key={order.id} onClick={() => handleGetDetail(order)} />)}
                                    </div>
                                }

                                {ordersTodayListOthers.length > 0 &&
                                    <div className='flex flex-col gap-3 opacity-75'>
                                        <div className='flex items-center gap-2 justify-center'>
                                            <hr className='border-gray-100 w-5' />
                                            <span className='text-nowrap font-semibold text-base text-shopfood-title'>{t('orders_today.completed_orders_title')}</span>
                                            <hr className='border-gray-100 w-full' />
                                        </div>
                                        {ordersTodayListOthers.map((order: any) =>
                                            <CardOrderToday order={order} key={order.id} onClick={() => handleGetDetail(order)} />
                                        )}
                                    </div>
                                }

                            </div>
                        }

                        {hasOrdersToday && <BoxContentEndScrollbars message={t('orders_today.end_of_list')} />}
                    </Scrollbars>


                    <div className={`absolute hidden md:block bottom-0 w-full h-2 shadow-reverse-md transition ${showShadow ? 'opacity-100' : 'opacity-0'}`}></div>
                </div>

            </div>

            {ordersTodayList.length > 0 && !loadingOrders &&
                <div className="p-4 md:pt-2">
                    <ButtonPrimary outline onClick={handleBackToHome} className='w-full'>
                        {t('orders_today.button_make_order')}
                    </ButtonPrimary>
                </div>
            }

        </div>
    )
}

export default OrdersToday;